/**
 * Static option lists for the tickets list FilterBuilder.
 * Values are the exact backend slugs accepted by the v4 /tickets API
 * (verified via probe — see phase-02 report for rejected keys).
 */
import type { FilterOption } from '@vnetwork/ui/data';

export const TICKET_STATUS_OPTIONS: FilterOption[] = [
  { value: 'opening', label: 'New' },
  { value: 'work-in-progress', label: 'In Progress' },
  { value: 'completed', label: 'Resolved' },
  { value: 'closed', label: 'Closed' },
  { value: 'escalated', label: 'Escalated' },
  { value: 'cancelled', label: 'Cancelled' },
];

// Legacy priority vocab: low/medium/high only (no critical).
export const TICKET_PRIORITY_OPTIONS: FilterOption[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export const TICKET_TYPE_GROUP_OPTIONS: FilterOption[] = [
  { value: 'support_request', label: 'Support Request' },
  { value: 'error_service', label: 'Error / Incident' },
  { value: 'service_request', label: 'Service Request' },
  { value: 'service', label: 'Service' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'change', label: 'Change' },
  { value: 'internal', label: 'Internal' },
];

export const TICKET_SOURCE_OPTIONS: FilterOption[] = [
  { value: 'portal', label: 'Portal' },
  { value: 'internal', label: 'Internal' },
  { value: 'email', label: 'Email' },
  { value: 'phone', label: 'Phone' },
  { value: 'service_creation', label: 'Service Creation' },
  { value: 'system', label: 'System' },
];

export const TICKET_SECURITY_TAG_OPTIONS: FilterOption[] = [
  { value: 'none', label: 'None' },
  { value: 'security', label: 'Security' },
  { value: 'service', label: 'Service' },
  { value: 'both', label: 'Both' },
];

/**
 * ticket_response_late — backend accepts "late" | "unlate" | "" as a string.
 * Sent inside the base64 filters blob via encodeTicketFilters.
 */
export const TICKET_RESPONSE_LATE_OPTIONS: FilterOption[] = [
  { value: 'late', label: 'Late' },
  { value: 'unlate', label: 'On time' },
];

/**
 * ticket_marjorable — backend accepts []string ["true"] | ["false"].
 * FilterBuilder sends a single value; encodeTicketFilters wraps it in an array.
 */
export const TICKET_MARJORABLE_OPTIONS: FilterOption[] = [
  { value: 'true', label: 'Major incident' },
  { value: 'false', label: 'Non-major' },
];
